var exports = {
  "S": "xe533113f--0aa8d8--image",
};

module.exports = exports;
